import { CardElement } from '@stripe/react-stripe-js'

import openErrorBannerAction from 'modules/banner/actions/open-error/index.js'
import { logUtil } from 'packages/src'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import getMessageErrorUtil from 'utils/error/get-message/index.js'
import { updateIsCreatingTokenStripeAction } from 'modules/stripe/redux/actions/update-is-creating-token/index.js'
import { updateTokenIdStripeAction } from 'modules/stripe/redux/actions/update-token-id/index.js'
import { updateShouldCreateTokenStripeAction } from 'modules/stripe/redux/actions/update-should-create-token/index.js'

const ANALYTIC_EVENT = {
  CREATE_STRIPE_TOKEN: 'CREATE_STRIPE_TOKEN',
  CREATE_STRIPE_TOKEN_SUCCESS: 'CREATE_STRIPE_TOKEN_SUCCESS',
  CREATE_STRIPE_TOKEN_ERROR: 'CREATE_STRIPE_TOKEN_ERROR',
  CREATE_STRIPE_TOKEN_SUCCESS_WITH_ERROR: 'CREATE_STRIPE_TOKEN_SUCCESS_WITH_ERROR'
}

/**
 * @param elements
 * @param stripe
 * @param onSubmit
 * @returns {(function(*, *): Promise<void>)|*}
 */
export const createTokenAndPlaceOrderStripePaymentAction = ({
  elements,
  stripe,
  onSubmit
}) => {
  return async (dispatch) => {
    try {
      logEventAnalyticsUtil(ANALYTIC_EVENT.CREATE_STRIPE_TOKEN)
      logUtil('createTokenAndPlaceOrderPaymentAction').debug('[start]')

      dispatch(updateIsCreatingTokenStripeAction(true))
      const cardElement = elements.getElement(CardElement)
      const payload = await stripe.createToken(cardElement)
      const {
        token,
        error
      } = payload

      if (token) {
        const tokenId = token.id
        dispatch(updateTokenIdStripeAction(tokenId))
        onSubmit(tokenId)
      }

      if (error) {
        logUtil('createTokenAndPlaceOrderPaymentAction#success').debug('succeeded, but had error payload=', payload)
        logUtil('createTokenAndPlaceOrderPaymentAction#success').error('error=', error)
        const errorMessage = getMessageErrorUtil(error)
        dispatch(openErrorBannerAction(error))
        logEventAnalyticsUtil(ANALYTIC_EVENT.CREATE_STRIPE_TOKEN_SUCCESS_WITH_ERROR, {
          errorMessage
        })
      } else {
        logUtil('createTokenAndPlaceOrderPaymentAction').debug('success payload=', payload)
        logEventAnalyticsUtil(ANALYTIC_EVENT.CREATE_STRIPE_TOKEN_SUCCESS)
      }

      dispatch(updateIsCreatingTokenStripeAction(false))
      dispatch(updateShouldCreateTokenStripeAction(false))
      return token.id
    } catch (error) {
      logUtil('createTokenAndPlaceOrderPaymentAction').error('error=', error)
      dispatch(openErrorBannerAction(error))
      const errorMessage = getMessageErrorUtil(error)
      logEventAnalyticsUtil(ANALYTIC_EVENT.CREATE_STRIPE_TOKEN_ERROR, {
        errorMessage
      })
      dispatch(updateIsCreatingTokenStripeAction(false))
      dispatch(updateShouldCreateTokenStripeAction(false))
    }
  }
}
